import { render } from "./ModalOrderStatus.vue?vue&type=template&id=3838a420"
import script from "./ModalOrderStatus.vue?vue&type=script&lang=js"
export * from "./ModalOrderStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__